import React from 'react';
import PropTypes from 'prop-types';
import { Table, Tag } from 'antd';
import moment from 'moment';

const Hover = ({
  columns, dataSource, expandRowByClick, pageSize, rowKey, ...rest
}) => (
  <Table
    {...rest}
    expandRowByClick={expandRowByClick}
    rowKey={rowKey}
    dataSource={dataSource}
    columns={[
      {
        title: 'Name',
        dataIndex: 'validation_name',
        key: 'validation_name'
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => <Tag color={record.status === 'Error' ? 'red' : record.status === 'Passed' ? 'green' : 'blue'}>{record.status}</Tag> // eslint-disable-line no-nested-ternary
      },
      {
        title: 'Requestor',
        dataIndex: 'request_user',
        key: 'request_user'
      },
      {
        title: 'Triggered',
        dataIndex: 'triggered_on',
        key: 'triggered_on',
        render: (text, record) => (moment(record.triggered_on)
          .format('YYYY-MM-DD HH:mm:ss'))
      },
      ...columns
    ]}
    pagination={{ pageSize }}
  />
);

Hover.propTypes = {
  columns: PropTypes.array,
  dataSource: PropTypes.array,
  expandRowByClick: PropTypes.bool,
  pageSize: PropTypes.number,
  rowKey: PropTypes.string
};

Hover.defaultProps = {
  columns: [],
  dataSource: [],
  expandRowByClick: true,
  pageSize: 5,
  rowKey: 'id'
};

export default Hover;
